import { TmHttpClient } from '@treasury/core/http';
import { Injectable } from '@treasury/utils/dependency-injection';

@Injectable()
export class NavigationsService {
    async fetchNavigationOptions() {
        return (await TmHttpClient.getInstance()).request('navigations', {
            method: 'GET',
        });
    }
}
